import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { SubCourseFormValues } from "src/models/SubCourse.model";
import SubCourseForm from "../Layout/SubCourseForm";
import { useParams } from "react-router-dom";
import { useAddSubCourseMutation, useGetAllPlansQuery } from "src/services/CourseServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
};

const AddSubCourseFormWrapper = ({ onClose }: Props) => {
  const { courseId } = useParams();

  const [addChapter] = useAddSubCourseMutation();

  const {
    data: allPlans,
    isLoading: allPlansLoading,
    isFetching: allPlansFetching,
  } = useGetAllPlansQuery({
    limit: 10,
    searchValue: "",
    params: ["planName", "noOfDays", "courseId"],
    page: 1,
    filterBy: [{ fieldName: "courseId", value: courseId }],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });
  // Form Initial Values
  const initialValues: SubCourseFormValues = {
    name: "",
    PlanDetails: allPlans?.data?.map((el: any) => {
      return {
        plan: {
          label: el?.planName,
          value: el?._id,
        },
        noOfDays: el?.noOfDays,
        fees: "",
        startDay: "",
        endDay: "",
      };
    }),
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    PlanDetails: array().of(object({
      fees: string().required("Please enter fees"),
      startDay: object().required("Please select start day"),
      endDay: object().required("Please select end day "),
    })),
  });

  // Handle Submit
  const handleSubmit = (
    values: SubCourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SubCourseFormValues>
  ) => {

    const formattedValues = {
      name: values?.name,
      courseId: courseId,
      planDetails: values?.PlanDetails?.map((el: any) => {
        return {
          planName: el?.plan?.label || '',
          planId: el?.plan?.value || '',
          fees: el?.fees || '',
          noOfDays: el?.noOfDays,
          startDay: el?.startDay?.value || '',
          endDay: el?.endDay?.value || '',
        }
      })
    }
    addChapter(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xl' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(allPlansLoading || allPlansFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <SubCourseForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddSubCourseFormWrapper;
